import config from '../config'
import { authHeader } from './auth-header'

export const inquiryService = {
  getAllInquiries,
  getInquiryById,
  createInquiry,
  updateInquiry,
  addAction,
  deleteInquiry,
}

function getAllInquiries () {
  const requestOptions = { method: 'GET', headers: authHeader() }
  return fetch(`${config.apiUrl}/inquiries/all`, requestOptions).then(handleResponse)
}

function getInquiryById (id) {
  const requestOptions = { method: 'GET', headers: authHeader() }
  return fetch(`${config.apiUrl}/inquiries/${id}`, requestOptions).then(handleResponse)
}

function createInquiry (data) {
  let body, headers = authHeader();
  if (data.attachments && data.attachments.length > 0) {
    delete headers['Content-Type'];
    body = new FormData();
    for (const key in data) {
      if (key === 'attachments') {
        data.attachments.forEach(file => {
          body.append('attachments', file);
        });
      } else if (data[key] !== null && data[key] !== undefined) {
        body.append(key, data[key]);
      }
    }
  } else {
    body = JSON.stringify(data);
    headers['Content-Type'] = 'application/json';
  }
  const requestOptions = { method: 'POST', headers, body }
  return fetch(`${config.apiUrl}/inquiries/create`, requestOptions).then(handleResponse)
}

function updateInquiry (data) {
  let body, headers = authHeader();
  if (data.attachments && data.attachments.length > 0) {
    delete headers['Content-Type'];
    body = new FormData();
    for (const key in data) {
      if (key === 'attachments') {
        data.attachments.forEach(file => {
          body.append('attachments', file);
        });
      } else if (data[key] !== null && data[key] !== undefined) {
        body.append(key, data[key]);
      }
    }
  } else {
    body = JSON.stringify(data);
    headers['Content-Type'] = 'application/json';
  }
  const requestOptions = { method: 'POST', headers, body }
  return fetch(`${config.apiUrl}/inquiries/update`, requestOptions).then(handleResponse)
}

function addAction (data) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  }
  return fetch(`${config.apiUrl}/inquiries/addaction`, requestOptions).then(handleResponse)
}

function deleteInquiry (id) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ id })
  }
  return fetch(`${config.apiUrl}/inquiries/delete`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data.Response
  })
}
